import { Link } from '@tanstack/react-router';
import { useEffect } from 'react';

export function NotFoundPage() {
  useEffect(() => {
    const root = document.getElementById('root');
    root?.setAttribute('data-app-notfound', '1');
    return () => root?.removeAttribute('data-app-notfound');
  }, []);

  return (
    <main className="grid min-h-screen place-items-center bg-background p-6 text-center">
      <div>
        <p className="text-sm font-semibold uppercase tracking-[0.2em] text-muted-foreground">Seattle Bus Times</p>
        <h1 className="mt-3 text-3xl font-semibold">This stop is not on the board.</h1>
        <Link className="mt-5 inline-block text-primary underline" to="/">
          Return to bus times
        </Link>
      </div>
    </main>
  );
}
